var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemsSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.412,
    height: 83.071,
    viewBox: "0 0 100.412 83.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(-1216 -420.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Items",
    transform: "translate(1216 420.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_38_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M99,54.385a7.924,7.924,0,0,0-6.51-3.406h-49.1a3.321,3.321,0,0,0,0,6.643h49.1a1.285,1.285,0,0,1,1.2,1.73l-9.2,24.768a1.291,1.291,0,0,1-1.2.838h-51.6L23.467,49.888a9.551,9.551,0,0,0-9.335-7.4H4.982a4.982,4.982,0,0,0,0,9.964h8.852L24.9,99.676a9.539,9.539,0,0,0,9.075,7.376,10.241,10.241,0,1,0,12.02.021H65.1a10.241,10.241,0,1,0,12.043,0h4.644a4.982,4.982,0,1,0,0-9.964H34.534L33.243,91.6H83.285a7.959,7.959,0,0,0,7.428-5.165l9.205-24.772A7.925,7.925,0,0,0,99,54.385Z",
    transform: "translate(0 -42.491)",
    fill: "#007cab"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "tick",
    d: "M13.923,0A13.923,13.923,0,1,0,27.846,13.923,13.939,13.939,0,0,0,13.923,0Zm7.995,11.571-8.747,8.747a1.969,1.969,0,0,1-2.784,0L5.928,15.86a1.969,1.969,0,1,1,2.784-2.784l3.066,3.065,7.355-7.355a1.969,1.969,0,0,1,2.785,2.785Z",
    transform: "translate(1268.206 434.965)",
    fill: "#007cab"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsSelected);
export default __webpack_public_path__ + "static/media/Items_Selected.4f455649890842f8c7725c537f67bbdd.svg";
export { ForwardRef as ReactComponent };